export const eligibilityId = {
  continueButton: 'eligibilityContinueButton',
};
